<template>
    <div class="projectMainLine-detail">
      <div class='project-template'>
          <el-form ref="projectMainLineForm" :rules="rules" :model="projectMainLine" size="mini" label-width="120px" class="projectMainLine-form">
              <el-row>
                  <div class="tools-bar">
                    <div class="tools-search" @keyup.enter="handleSearch">
                          <el-input style="width:260px" maxlength="100" v-model.trim="searchParams.searchName" placeholder="名称">
                            <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
                        </el-input>
                        <el-button  icon="el-icon-view"  title="查看全部主线" @click="handleViewAllProjectMainLine" circle></el-button>
                    </div>
                    <div class="tools-btn-group">
                        <el-button  v-if="!isInstance" icon="el-icon-circle-plus" type="success" size="mini" @click="handleOpenFolder('')" plain>新建文件夹</el-button>
                        <el-button v-if="isInstance && !isFullScreen"  style="margin-left:15px;float: right" class='print-class'  type="primary" icon="el-icon-rank"  size="mini" @click.stop="handleFullScreen()">全屏</el-button>
                        <el-button v-if="isInstance" style="margin-left:15px;float: right" title='表单库' type="primary" icon="el-icon-goods" circle @click="handleTimeTemplateForms()"></el-button>
                        <el-button v-if="isInstance" style="margin-left:15px;float: right" title='导出' type="primary" icon="el-icon-download" circle @click="exportTimeConfigDetailToExcel()"></el-button>
                        <el-button v-if="isInstance" style="margin-left:15px;float: right" title='预览流程模板' icon="el-icon-view" circle @click="handleNavViewDetail()"></el-button>
                        <el-button v-if="isInstance" style="margin-left:15px;float: right" title='查看甘特图' icon="el-icon-s-data" circle @click="handleNavViewTimeGantt()"></el-button>
                        <el-button v-if="isInstance && ifConfigMainLine" style="margin-left:15px;float: right" title='根据第一个任务的开始时间及各任务的工作时长，自动计算后续任务的时间' type="primary" icon="el-icon-time" circle @click="handleSaveConfigDetail(true)"></el-button>
                        <!-- <el-tooltip content="点击切换：展开/收起 所有的子任务节点" placement="top"> -->
                            <el-switch
                              v-if="isInstance"
                              style="margin-left:15px;margin-top: 4px;float: right"
                              v-model="expandAll"
                              active-text=""
                              inactive-text=""
                              title="点击切换：展开/收起 所有的子任务节点"
                              @change="changeSwitch"
                            >
                            </el-switch>
                    </div>
                  </div>
                  <div class="projectTemplate">  
                    <span class="show-file-info">
                      已全部加载，共{{mainLineListLength}}个
                      </span>
                      <el-breadcrumb separator-class="el-icon-arrow-right">
                        <transition-group name="breadcrumb">
                            <el-breadcrumb-item v-for="(item,index) in directoryList" :key="item.key">
                                <span v-if="item.key==='-1'"><font color='green'>{{item.meta.title}}</font></span>
                                <span v-else-if="item.path===''">{{item.meta.title}}</span>
                                <router-link v-else :to="item.path" @click.native="handleBreadcrumb(item,index)">{{item.meta.title}}</router-link>
                            </el-breadcrumb-item>
                        </transition-group>
                    </el-breadcrumb>
                  </div>
                  <!-- <el-col :span="6">
                  <el-form-item label="最终完成时间" prop="planFinalEndTime">
                        <el-date-picker
                            :readonly="isInstance"
                            v-model="projectMainLine.planFinalEndTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            :editable="true"
                            placeholder="选择日期时间"
                        >
                        </el-date-picker>
                    </el-form-item>
                  </el-col> -->
              </el-row>
              <el-row v-if="!isInstance" >
                  <el-col :span="12">
                      <el-switch
                          style="margin-left: 8%;margin-top: -4%;"
                          v-model="expandAll"
                          active-text=""
                          inactive-text=""
                          title="点击切换：展开/收起 所有的子任务节点"
                          @change="changeSwitch"
                        >
                        </el-switch>
                  </el-col>
              </el-row>
              <!-- <el-collapse class="process-detail-Forms" v-model="collapseActiveName"  v-if="isShowDiagram" accordion>
                <el-collapse-item title="流程模板" name="1">
                    <ProcessDetailView ref="detailView" :viewParams="viewParams"/>
                  </el-collapse-item>
              </el-collapse> -->
              <!-- <TreeTableExt height="340px" :data="taskTimeTreeList" :isShowBtn="isShowBtn" :isShowCheckbox="false" :expandAll="true" :columns="taskTimeTreeColumns" border/> -->
          <TreeTableDrag ref="treeTableDragRef" :key="loadTimer"  :isdraggable="true" :treeColumns="treeColumns" :treeDatas="treeDatas" :tableHeight="tableLocalHeight" @treeDataChange="treeDataChange"></TreeTableDrag>
          </el-form>
        </div>
         <!-- 显示详细 -->
        <el-dialog
            title="流程明细"
            :fullscreen=true
            append-to-body
            :visible.sync="isShowDiagram"
            custom-class="diagram-dialog">
            <ProcessDetailView ref="detailView" :viewParams="viewParams" />
        </el-dialog>
         <el-dialog
              title="任务配置"
              :visible.sync="isShowTaskTimeDialog"
              top="4vh"
              width="50%"
              append-to-body
              >
              <el-form :model="configDetailObj" ref="configDetailObjForm" size="mini" label-width="120px">
                 <el-row >
                      <el-form-item label="任务类型">
                         <el-tag  v-if="configDetailObj.pId && configDetailObj.pId!==0" type="info">子任务</el-tag>
                         <el-tag v-else type="success">主任务</el-tag>
                      </el-form-item>
                  </el-row>
                  <el-row >
                      <el-form-item label="任务节点">
                         <template v-if="configDetailObj.pId && configDetailObj.pId!==0" >
                           <el-input style="width:38%" disabled v-model="configDetailObj.pLabel"></el-input>
                         </template>
                        <template v-else>
                            <el-input  style="width:38%" disabled v-model="configDetailObj.label"></el-input>
                        </template>

                      </el-form-item>
                  </el-row>
                  <el-row v-if="configDetailObj.pId && configDetailObj.pId!==0">
                      <el-form-item
                         prop="label"
                         label="子任务名称"
                         :rules="[
                            { required: true, message: '请输入子任务名称', trigger: 'change' }
                          ]"
                      >
                        <el-input style="width:38%" v-model="configDetailObj.label"></el-input>
                      </el-form-item>
                  </el-row>
                  <el-row>
                        <el-form-item  label="工作时长(天)"
                         prop="workingDays"
                         :rules="[
                            { required: true, message: '请输入子任务名称', trigger: 'change' }
                          ]">
                           <el-input-number v-model="configDetailObj.workingDays" :min="0" :max="99999"></el-input-number>
                           <!-- <el-input type="number" placeholder="" v-model="configDetailObj.workingDays"></el-input> -->
                        </el-form-item>
                  </el-row>
                  <el-row v-if="isInstance" ><!-- 项目模板设置时从任务配置信息处带过来 -->
                      <el-form-item label="任务负责人">
                          <template  v-if="configDetailObj.pId && configDetailObj.pId!==0" >
                              <el-input v-if="this.ifConfigMainLine" style="width:38%"  readonly v-model="selectedUser.selectedUserNames" @focus="chooseUser" ></el-input>
                              <el-input  v-else style="width:38%"  disabled v-model="selectedUser.selectedUserNames" ></el-input>
                          </template>
                           <template v-else >
                                <el-input   style="width:38%"  disabled v-model="selectedUser.selectedUserNames" ></el-input>
                              <template v-if="configDetailObj.taskStatus!==2 && instancesInfo.canInterveneProcess" >
                                <el-tooltip  content="当前任务节点为主任务，请使用【流程任务干预】功能修改主任务的负责人" effect="light" placement="top">
                                   <el-button  type="primary" size="mini" icon="el-icon-warning" title="流程任务干预" circle @click="handelSetMainTask()"></el-button>
                                </el-tooltip>
                              </template>
                          </template>
                          <UserOrgPop  :multiple="false" :isShowUserOrg='isShowUserOrg'  :selectedUser="selectedUser" ref="userOrgPop" @nodeClick="selectTrigger"  />
                      </el-form-item>
                  </el-row>

                  <el-row  v-if="isInstance" >
                      <el-form-item label="计划开始时间">
                        <el-date-picker
                         :readonly="!isInstance"
                          v-model="configDetailObj.planStartTime"
                          type="date"
                          value-format="yyyy-MM-dd"
                          :editable="true"
                          :clearable="true"
                        />
                      </el-form-item>
                  </el-row>
                   <el-row  v-if="isInstance" >
                        <el-form-item label="计划结束时间">
                           <el-date-picker
                            :readonly="!isInstance"
                            v-model="configDetailObj.planEndTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            :editable="true"
                            :clearable="true"
                          />
                        </el-form-item>
                    </el-row>
                    <el-row  v-if="isInstance"  >
                        <el-form-item label="任务提醒时间">
                           <el-date-picker
                            :readonly="!isInstance"
                            v-model="configDetailObj.warningTime"
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :editable="true"
                            :clearable="true"
                            default-time="12:00:00"
                          />
                        </el-form-item>
                    </el-row>

                    <el-row   v-if="isInstance" style="margin-top:4%">
                        <el-form-item  label="实际进度">
                          <ProcessSlider :key="loadTimer" ref="processSliderRef" :min=0 :max=100 :value="configDetailObj.processVal" v-model="configDetailObj.processVal"></ProcessSlider>
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-form-item  label="任务描述">
                           <el-input v-model="configDetailObj.taskNodeDes" style="width:90%;overflow-x:hidden;"  type="textarea" :autosize="{ minRows: 2, maxRows: 4}"></el-input>
                        </el-form-item>
                    </el-row>
              </el-form>
              <span slot="footer" class="dialog-footer">
                  <el-button @click="isShowTaskTimeDialog = false">取 消</el-button>
                  <el-button v-if="this.ifConfigMainLine || (this.configDetailObj.pId && this.configDetailObj.pId !== 0 && this.configDetailObj.assigneeId === this.loginUserId)" type="primary" :loading="!isShowTaskTimeDialog" @click="handleSaveConfigDetail(false)">保存</el-button>
              </span>
          </el-dialog>
        <el-dialog
            title="时间甘特图"
            :fullscreen=true
            append-to-body
            :key="loadTimer"
            :visible.sync="isShowTimeGantt"
            custom-class="diagram-dialog">
            <TimeConfigGantt ref="timeConfigGantt" />
        </el-dialog>

        <div>
        <el-dialog
              custom-class="task-edit-dialog"
              :title="taskTile"
              :visible.sync="isShowEleEditor"
              top="2vh"
              width="88%"
              :fullscreen="true"
              append-to-body
              >
              <!-- 用户任务 节点 -->
              <ElementEditor :key="loadTimer" :taskData="taskData" :processInstance="instancesInfo" @hideMainSaveBtn="hideMainSaveBtn"/>
              <span slot="footer" class="dialog-footer">
                  <el-button @click="isShowEleEditor = false">取 消</el-button>
                  <el-button v-if="isShowSaveBtn" type="primary" :loading="!isShowEleEditor" @click="handleSaveConfig">保存配置</el-button>
              </span>
          </el-dialog>
          <el-dialog
              custom-class="task-edit-dialog"
              :title="taskTile"
              :visible.sync="isShowTimeTemplateInstanceFormsDialog"
              top="2vh"
              width="88%"
              :fullscreen="true"
              append-to-body
              >
              <TimeTemplateInstanceForms :key="loadTimer" :timeTemplateInstanceId="timeTemplateInstanceId"/>
              <span slot="footer" class="dialog-footer">
                  <el-button @click="isShowTimeTemplateInstanceFormsDialog = false">取 消</el-button>
              </span>
          </el-dialog>
           <el-drawer
              title="节点详情"
              v-if="isShowTaskDetailDrawer"
              :visible.sync="isShowTaskDetailDrawer"
              :direction="direction"
              custom-class="needWorkingPop"
              size="90%"
                >
              <div style="height: 100%;">
                <TaskDetail
                  class="drawerWorkTask"
                  v-if="isShowTaskDetailDrawer"
                  :taskInfo="taskInfo"
                  :isNewPage ="true"
                  :key="loadTimer"
                />
              </div>
            </el-drawer> 
            <el-dialog
              title="节点详情"
              :fullscreen="true"
              append-to-body
              custom-class="needWorkingPop"
              :visible.sync="isShowTaskDetail"
              >
              <div style="height: 100%;">
                  <TaskDetail
                    :key="loadTimer"
                    class="popDetailTaskClass"
                    ref="taskDetailRef" 
                    :taskInfo="taskInfo"
                    :isNewPage ="true"
                    @taskClaim="handleTaskClaim"
                    @taskComplete="handleTaskComplete"
                    @taskDelete="handleTaskDelete"
                    @taskTemporarySave="handleTaskTemporarySave"
                    @transferTask="transferTask"
                    @refreshTaskDetail ="refreshTaskDetail"
                  />
              </div>
          </el-dialog>
            <el-dialog
                class='processPopClass'
                title="启动流程"
                width="80%"
                top="0vh"
                append-to-body
                :visible.sync="isShowStartProcessDialog">
                <ProcessInstancePop :key="loadTimerProcess" ref="processInstancePop" :taskInfo="taskInfo" @refreshSubProcess="refreshSubProcess" @handleClosePop="handleClosePop"/>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import { processTaskTemporarySave, getSerialNumberDepartment, getSerialNumber2, getSerialNumber, getSerialNumberDepAndOption, processTaskComplete, processTaskDelete, transferAssignee, getProcessTaskDetail, interveneProcessTaskConfig, getProcessServiceInstanceConfig, getProjectMainLineTreeList, getProcessInstanceTreeList, saveServiceTimeTemplate, saveServiceTimeTemplateInstance, deleteServiceTimeTreeNode, deleteServiceTimeInstanceTreeNode, getProcessTemplateList, getServiceTimeTreeList, getServiceTimeTreeInstanceList, getSerialNumberPlus } from '@/data-model';
    import mixinsNav from '@/mixins/mixins-nav';
    import { cloneDeep, isEmpty, defaultsDeep } from 'lodash';
    // import TreeTableExt from '@/components/TreeTableExt';
    import TreeTableDrag from '@/components/TreeTableDrag';
    import ProcessSlider from '@/components/ProcessSlider';
    import { API_PROCESS_TIME_CONFIG_DETAIL_TO_EXCEL } from '@/common/constants';
    import ProcessDetailView from '@/pages/process/ProcessList/ProcessDetailView';
    import { defaultElementData } from '@/pages/process/MyProcess/defaultData';
    import ElementEditor from '@/pages/process/ProcessEditor/components/ElementEditor';
    // import TimeGantt from '@/pages/operation/TimeGantt';
    import TimeConfigGantt from '@/pages/process/TimeConfig/TimeConfigGantt/TimeConfigGantt';
    import DataOperateEdit from '@/pages/process/ProcessEditor/components/DataOperateEdit';
    import ProjectMainLineForms from './ProjectMainLineForms';
    import { getGlobalConf } from '@/utils/grocer';

    export default {
        components: {
            TreeTableDrag,
            ProcessSlider,
            ProcessDetailView,
            // TimeGantt,
            TimeConfigGantt,
            ElementEditor,
            DataOperateEdit,
            ProjectMainLineForms
        },
        mixins: [ mixinsNav ],
        data () {
            return {
                syscnt: 0,
                isShowTaskDetail: false,
                isShowStartProcessDialog: false,
                loadTimerProcess: '',
                rootProcessInstanceId: '',
                mainLineListLength: 0,
                treeId: '', // 当前主线目录id
                directoryList: [], // 主线目录导航栏
                direction: 'rtl',
                taskInfo: {},
                rootPath: '/workspace/projectMainLine',
                isShowTaskDetailDrawer: '',
                tableLocalHeight: this.tableHeight,
                timeTemplateInstanceId: '',
                isShowTimeTemplateInstanceFormsDialog: false,
                dataOperate: {forms: [], dataSource: 2},
                isTimeConfig: true,
                taskData: {},
                taskTile: '',
                loadTimer: '',
                isShowSaveBtn: true,
                isShowEleEditor: false,
              	// eslint-disable-next-line no-tabs
              	isShowTimeGantt: false,
                expandAll: false,
                collapseActiveName: '1',
                isShowDiagram: false,
                viewParams: {},
                isShowBtn: false,
                isShowTreeTable: false,
                processTemplateList: [],
                selectedProcess: {},
                isShowTaskTimeDialog: false,
                configDetailObj: {
                    label: '',
                    assigneeId: '',
                    assigneeName: '',
                    planStartTime: '',
                    planEndTime: '',
                    warningTime: '',
                    workingDays: 0,
                    processVal: 0,
                    taskStatus: null,
                    taskInstanceId: null
                },
                treeColumns: [
                    {
                        title: '主线顺序',
                        type: 'selection',
                        // field: 'viewOrder',
                        field: 'orderNum',
                        width: 160,
                        align: 'center'
                    },
                    {
                        title: '主线节点',
                        type: 'action',
                        field: 'label',
                        width: 280,
                        align: 'left',
                        actions: [
                            {
                                text: '',
                                onclick: this.handleEnterSubMainLine,
                                formatter: (item) => {
                                    if (item.root) {
                                        return item.label;
                                    } else {
                                        return '<a  style="cursor:pointer;">' + item.label + '</a>';
                                    }
                                }
                            }
                        ]
                    },
                    {
                        title: '负责人',
                        field: 'assigneeUserName',
                        width: 100,
                        align: 'center'
                    },
                    {
                        title: '进度',
                        field: 'nodeTypeName',
                        width: 180,
                        align: 'center'
                    },
                    {
                        title: '发起时间',
                        field: 'beginDate',
                        width: 180,
                        align: 'center'
                    },
                    {
                        title: '结束时间',
                        field: 'endDate',
                        width: 180,
                        align: 'center'
                    },
                    {
                        title: '状态',
                        field: 'statusName',
                        width: 100,
                        align: 'center'
                    }
                    // {
                    //     title: '状态',
                    //     field: 'taskStatus',
                    //     width: 100,
                    //     align: 'center',
                    //     formatter: (item) => {
                    //         let status = '未开始';
                    //         if (item.taskStatus === 1) {
                    //             status = '进行中';
                    //         } else if (item.taskStatus === 2) {
                    //             status = '已完成';
                    //         } else if (item.taskStatus === 4) {
                    //             status = '待认领';
                    //         } else if (item.taskStatus === 5) {
                    //             status = '已延期';
                    //         } else if (item.taskStatus === 6) {
                    //             status = '快到期';
                    //         }
                    //         return status;
                    //     }
                    // }
                ],
                taskProcessVal: {
                    title: '任务进度',
                    field: 'processVal',
                    width: 120,
                    align: 'center',
                    formatter: (item) => {
                        // console.log(item);
                        if (item.processVal) {
                            return item.processVal + '%';
                        }
                        // else {
                        //     return '';
                        // }
                    }
                },
                taskConfigBtn: {
                    // title: '操作',
                    title: '',
                    type: 'action',
                    width: 160,
                    align: 'center',
                    actions: [
                        {
                            text: '',
                            onclick: this.configSubTask,
                            formatter: (item) => {
                                return "<button type='button' class='el-button el-button--warning el-button--mini is-circle' title='配置子节点'><!----><i class='el-icon-setting'></i><!----></button>";
                            }
                        },
                        {
                            text: '',
                            onclick: this.addSubTask,
                            formatter: (item) => {
                                return "<button type='button' class='el-button el-button--primary el-button--mini is-circle' title='增加子节点'><!----><i class='el-icon-plus'></i><!----></button>";
                            }
                        },
                        {
                            text: '',
                            onclick: this.deleteSubTask,
                            formatter: (item) => {
                                if (item.pId !== 0) {
                                    return "<button style='margin-left:5px' type='button' class='el-button el-button--danger el-button--mini is-circle' title='删除节点'><!----><i class='el-icon-delete'></i><!----></button>";
                                }
                            }
                        }
                    ]
                },
                taskTimeArr: [
                    {
                        title: '计划开始时间',
                        field: 'planStartTime',
                        width: 120,
                        align: 'center'
                    },
                    {
                        title: '计划结束时间',
                        field: 'planEndTime',
                        width: 120,
                        align: 'center'
                    }
                ],
                taskWarningTime: {
                    title: '任务提醒时间',
                    field: 'warningTime',
                    width: 160,
                    align: 'center'
                },
                taskWorkingDays: {
                    title: '工作时长(天)',
                    field: 'workingDays',
                    width: 90,
                    align: 'center'
                },
                assigneeName: {
                    title: '负责人',
                    field: 'assigneeName',
                    width: 60,
                    align: 'center'
                },
                treeDatas: [],
                projectMainLine: {
                    id: '',
                    templateId: '',
                    templateName: '',
                    processServiceId: '',
                    processServiceName: '',
                    deploymentId: '',
                    planTotalDays: 0,
                    planFinalEndTime: '',
                    remarks: ''
                },
                taskSumTotalDays: 0,
                rules: {
                    templateName: [
                        { required: true, message: '请输入模板名称名', trigger: 'change' },
                        { min: 2, max: 200, message: '长度在 2 到 200 个字符', trigger: 'change' }
                    ],
                    processServiceId: [
                        { required: true, message: '请选择流程方案', trigger: 'change' }
                    ],
                    planTotalDays: [
                        { required: true, message: '请输入总计划时长', trigger: 'change' }
                    ]
                },
                isShowUserOrg: false,
                selectedUser: {
                    selectedUserIds: '',
                    selectedUserNames: ''
                },
                currentPItem: {},
                oldConfigDetailObj: {},
                loginUserId: '',
                searchParams: {
                    complateTreeMode: false,
                    pageSize: 100000,
                    currentPage: 1,
                    isSearchNowTasks: false,
                    instanceId: '', // 流程实例id
                    processServiceId: '', // 流程模板对应的方案ID
                    startedByUserId: '', // 流程发起人ID
                    assigneeUserId: '', // 流程负责人Id
                    hasSubProcess: '', // 默认全部
                    isTree: true, // 树列表结构
                    allProcessInstance: true, // 查询所有流程实例
                    processStartedBy: '', // 默认全部1我发起2我参与
                    serviceName: '',
                    state: '' // 流程状态 ：默认 全部
                }
            };
        },
        props: {
            timeConfigObj: {
                type: Object
            },
            isInstance: {
                type: Boolean,
                default: false
            },
            instancesInfo: {
                type: Object
            },
            tableHeight: {
                type: Number,
                default: 280
            },
            ifConfigMainLine: {
                type: Boolean,
                default: false
            },
            isFullScreen: { // 是否全屏
                type: Boolean,
                default: true
            }
        },
        created () {
            // this._initProcessTemplateList();
            // this._initPage();
            this.isShowSaveBtn = true;
            let currentUserStr = sessionStorage.getItem('currentUserInfo');
            if (currentUserStr) {
                let currentUserInfo = JSON.parse(currentUserStr);
                this.loginUserId = currentUserInfo.userId;
            }
        },
        methods: {
            async _initPage (obj) {
                // this.treeColumns.push(this.assigneeName);
                // if (this.isInstance) {
                //     this.taskTimeArr.forEach(element => {
                //         this.treeColumns.push(element);
                //     });
                //     // this.treeColumns = this.treeColumns.concat(this.taskTimeArr);
                //     this.treeColumns.push(this.taskWarningTime);
                //     // if (this.isFullScreen) { // 全屏时显示
                //     this.treeColumns.push(this.taskProcessVal);
                //     // }
                // }
                // this.treeColumns.push(this.taskWorkingDays);
                if (this.ifConfigMainLine) {
                    this.treeColumns.push(this.taskConfigBtn);
                }
                // await this._initProcessTemplateList();
    
                // if (this.projectMainLine.id) {
                //     await this._initServiceTimeTreeList(this.projectMainLine.processServiceId);
                // } else {
                //     this.treeDatas = [];
                //     setTimeout(() => {
                //         this.$refs.treeTableDragRef._resetData(this.treeDatas);
                //     }, 0);
                // }
                // this.initTotalDays();
                this.rootProcessInstanceId = obj.processInstanceId;
                await this.setBreadcrumb(obj);
                this.expandAll = true;
                this.changeSwitch();
            },
            async queryTreeList (obj) {
                this.treeDatas = [];
                if (this.isInstance) {
                    let loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    this.searchParams.processInstanceId = obj.processInstanceId;
                    // console.log(obj.isAll);
                    if (obj.isAll) {
                        this.searchParams.showAllProjectMainLineTree = 1;
                    }
                    let treeList = await getProjectMainLineTreeList(this.searchParams);
                    if (treeList && treeList.length) {
                        this.treeDatas = treeList;
                        this.treeDatas[0].root = true;
                        this.mainLineListLength = this.treeDatas[0].children ? this.treeDatas[0].children.length : 0;
                        this.tableLocalHeight = 688;
                        this.loadTimer = new Date().getTime();
                        await this.$refs.treeTableDragRef._resetData(this.treeDatas);
                        this.$refs.treeTableDragRef._resetExpandAll(this.expandAll);
                    }
                    loading.close();
                }
            },
            async _initServiceTimeTreeList (id) {
                let selectedItem = {};
                for (let item of this.processTemplateList) {
                    if (id === item.processServiceId) {
                        selectedItem = item;
                        break;
                    }
                }
                if (selectedItem.processServiceId) {
                    this.selectedProcess = selectedItem;
                    this.projectMainLine.processServiceId = selectedItem.processServiceId;
                    this.projectMainLine.deploymentId = selectedItem.deploymentId;
                    this.projectMainLine.processDefinitionId = selectedItem.id;
                }
                let loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let treeList = [];
                if (this.isInstance) {
                    treeList = await getServiceTimeTreeInstanceList({processInstanceId: this.instancesInfo.id, templateId: this.projectMainLine.templateId});
                } else {
                    treeList = await getServiceTimeTreeList({templateId: this.projectMainLine.id, processServiceId: this.projectMainLine.processServiceId, processDefinitionId: this.projectMainLine.processDefinitionId, deploymentId: this.projectMainLine.deploymentId});
                }

                this.treeDatas = treeList;
                await this.$refs.treeTableDragRef._resetData(this.treeDatas);
                loading.close();
                this.isShowDiagram = false;
            },
            async _initProcessTemplateList () {
                let { data } = await getProcessTemplateList({ state: 3, currentPage: 0, pageSize: 500 });// 查出所有版本的流程方案
                this.processTemplateList = data;
            },
            handleNavViewDetail () {
                // console.log(this.isInstance);
                if (this.isInstance) {
                    this.viewParams.id = this.instancesInfo.processDefinitionIdExt;
                } else {
                    // console.log(this.selectedProcess);
                    this.viewParams.id = this.selectedProcess.processDefinitionId;
                }
                this.viewParams.pModelId = '';
                this.viewParams.viewDiagram = true;
                this.isShowDiagram = true;
                // console.log(this.viewParams);
                setTimeout(() => {
                    this.$refs.detailView.setProcessState(this.viewParams);
                }, 0);
            },
            async handleTimeconfigFormSave () {
                let result = true;
                // setTimeout(() => {
                await this.$refs.treeTableDragRef._submitData(this.treeDatas);
                // }, 0);
                this.$refs['projectMainLineForm'].validate(async (valid) => {
                    if (valid) {
                        if (this.projectMainLine.planTotalDays !== this.taskSumTotalDays) {
                            this.$confirm(`总计划时长与任务列表里的所有任务时长累积时间不一致，您确定要继续保存模板吗？`, '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(async (res) => {
                                this.saveData();
                            }).catch(() => {
                                result = false;
                            });
                        } else {
                            this.saveData();
                        }
                    } else {
                        result = false;
                    }
                });
                // this.$emit('hideFullScreenDialogForTime');
                return result;
            },
            async saveData () {
                this.projectMainLine.treeDatas = this.$refs.treeTableDragRef.getCurrentTreeData();
                let loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                if (this.isInstance) {
                    this.projectMainLine.processInstanceId = this.instancesInfo.id;
                    await saveServiceTimeTemplateInstance(this.projectMainLine);
                    this.$emit('initProjectMainLine');
                } else {
                    await saveServiceTimeTemplate(this.projectMainLine);
                    this.$emit('handleSearch');
                }
                loading.close();
            },
            handleCancel () {
                if (this.timeconfigInfo) {
                    // setTimeout(() => {
                    //     this.$emit('hideSidebox');
                    // }, 100);
                } else {
                    // this.navCronjobList();
                }
            },
            async onEdit (item) {
                // this.initForm();
                // this.oldConfigDetailObj = cloneDeep(item);
                // this.configDetailObj = item;
                // if (!this.configDetailObj.workingDays) {
                //     this.configDetailObj.workingDays = 0;
                // }
                // this.selectedUser.selectedUserIds = item.assigneeId;
                // this.selectedUser.selectedUserNames = item.assigneeName;
                // if (!item.hasOwnProperty('processVal') || !item.processVal) {
                //     this.configDetailObj.processVal = 0;
                // }
                // this.loadTimer = new Date().getTime();
                // this.isShowTaskTimeDialog = true;
                console.log(item);
                this.handleViewTaskDetail(item);
            },
            async deleteSubTask (item) {
                this.$confirm('您确定要删除子任务【' + item.label + '】吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    let treeDatas = this.$refs.treeTableDragRef.getCurrentTreeData();
                    for (var i = 0; i < treeDatas.length; i++) {
                        if (treeDatas[i].id === item.id) {
                            treeDatas.splice(i, 1);
                        } else if (treeDatas[i].children) {
                            this.deleteChildrenItem(treeDatas[i].children, item.id);
                        }
                    }
                    // this.loadTimer = new Date().getTime();
                    if (this.isInstance) {
                        this.isRefresh = false;
                    } else {
                        this.expandAll = true;
                    }
                    if (this.isInstance) {
                        await deleteServiceTimeInstanceTreeNode(item.id, this.instancesInfo.id);
                    } else {
                        await deleteServiceTimeTreeNode(item.id);
                    }
                    // await this.handleSaveConfigDetail(false);
                });
            },
            deleteChildrenItem (arr, id) {
                let innerOrder = 0;
                arr.forEach((v, i) => {
                    v.open = true;
                    if (v.id === id) {
                        arr.splice(innerOrder, 1);
                    }
                    if (v.children) {
                        this.deleteChildrenItem(v.children, id);
                    }
                    innerOrder++;
                });
            },
            async addSubTask (item) {
                // this.initForm();
                // // this.configDetailObj = cloneDeep(item);
                // this.configDetailObj.label = '';
                // this.configDetailObj.workingDays = 0;
                // this.configDetailObj.pId = item.id;
                // this.configDetailObj.pLabel = item.label;
                // this.configDetailObj.isAddSubTask = true;
                // this.currentPItem = item;
                // this.configDetailObj.viewOrder = 0;
                // this.configDetailObj.id = this.getRandomNumber();
                // this.configDetailObj.isNew = true;
                // this.configDetailObj.opMode = 0;
                // // console.log(this.configDetailObj.id);
                // if (!item.hasOwnProperty('processVal') || !item.processVal) {
                //     this.configDetailObj.processVal = 0;
                // }
                // this.loadTimer = new Date().getTime();
                // this.isShowTaskTimeDialog = true;
                this.taskInfo = await getProcessTaskDetail(item.subProcessFirstTaskInstanceId);
                console.log(this.taskInfo);
                let process = {};
                process.id = item.subProcessDefinitionId;
                process.processServiceId = item.subProcessServiceId;
                process.deploymentId = item.subDeploymentId;
                process.parentProcessInstanceId = item.id;
                process.parentProcessInstanceName = item.label;
                console.log(process);
                this.loadTimerProcess = new Date().getTime();
                setTimeout(async () => { // 默认回显值
                    await this.$refs.processInstancePop.handleStartProcess(process);
                }, 0);

                this.isShowStartProcessDialog = true;
            },
            async configSubTask (item) {
                await this.onEdit(item);
                // this.loadTimer = new Date().getTime();
                // this.isShowTaskTimeDialog = true;
            },
            getRandomNumber () {
                return Number((new Date().getTime()).toString().substr(4, 13));
            },
            initForm () {
                this.configDetailObj = {
                    label: '',
                    assigneeId: '',
                    assigneeName: '',
                    planStartTime: '',
                    planEndTime: '',
                    warningTime: '',
                    workingDays: 0,
                    processVal: 0,
                    pId: 0
                };
                this.selectedUser = {
                    selectedUserIds: '',
                    selectedUserNames: ''
                };
                this.currentPItem = {};
                this.oldConfigDetailObj = {};
            },
            async handleSaveConfigDetail (isRefresh) {
                // this.projectMainLine.planTotalDays = 0;
                if (isRefresh) {
                    this.expandAll = true;
                }

                let flg = false;
                let isComputeDays = false;// 是否自动计算天数，设置主任务暂时不用，设置子任务时需要
                if (this.configDetailObj.isAddSubTask) { // 增加子任务节点
                    this.$refs['configDetailObjForm'].validate(async (valid) => {
                        if (!valid) {
                            flg = true;
                            return false;
                        }
                    });
                    if (flg) { // 校验必填项
                        return;
                    }
                    if (!this.currentPItem.hasOwnProperty('children')) {
                        this.currentPItem.children = [];
                    }
                    this.currentPItem.open = true;
                    if (this.configDetailObj.workingDays) {
                        this.currentPItem.workingDays = Number(this.configDetailObj.workingDays) + Number(this.currentPItem.workingDays);
                    }
                    this.configDetailObj.opMode = 0;
                    this.currentPItem.children.push(this.configDetailObj);
                    await this.$refs.treeTableDragRef.onTreeDataChange(this.treeDatas);
                    this.expandAll = true;
                }
                if (this.configDetailObj.pId !== 0) { // 设置子任务
                    isComputeDays = true;
                }
                let treeDatas = this.$refs.treeTableDragRef.getCurrentTreeData();
                if (isComputeDays || isRefresh) {
                    //  if (!this.configDetailObj.isAddSubTask || isRefresh) {
                    // if (isRefresh) {
                    // setTimeout(() => {
                    await this.$refs.treeTableDragRef._resetData(treeDatas);
                    // }, 0);
                    // let dVal = this.configDetailObj.workingDays - this.oldConfigDetailObj.workingDays;// 得到当前任务天数的变化值(可能为负数)
                    // this.sumParentDays(treeDatas, dVal);
                    await this.sumParentDays(treeDatas);// 重新计算日期天数
                    this.sumFisrtLevel(treeDatas);
                }

                if (this.isInstance && this.$refs.processSliderRef && !isRefresh) {
                    this.configDetailObj.processVal = this.$refs.processSliderRef.getCurrentProcessVal();
                }
                let isBatchUpdateDate = false;
                // if ((this.isInstance && treeDatas.length > 0 && treeDatas[0].taskId === this.configDetailObj.taskId) || isRefresh) {
                // if ((this.isInstance && treeDatas.length > 0) || isRefresh) {
                if (this.isInstance && treeDatas.length > 0 && isRefresh) {
                    isBatchUpdateDate = true;
                    if (isEmpty(treeDatas[0].planStartTime)) {
                        this.$message({message: '请输入第一个任务的计划开始时间', type: 'warning'});
                        return;
                    }
                }
                // console.log(isBatchUpdateDate);
                this.taskSumTotalDays = 0;
                this.sumChildrenDays(treeDatas, treeDatas[0].planStartTime, isBatchUpdateDate);
                if (isBatchUpdateDate) {
                    this.projectMainLine.planFinalEndTime = treeDatas[treeDatas.length - 1].planEndTime;
                }
                this.treeDatas = cloneDeep(treeDatas);

                this.$refs.treeTableDragRef._resetExpandAll(this.expandAll);
                await this.$refs.treeTableDragRef._resetData(this.treeDatas);
                this.projectMainLine.planTotalDays = this.taskSumTotalDays;
                if (this.isInstance && (this.ifConfigMainLine || (this.configDetailObj.pId && this.configDetailObj.pId !== 0 && this.configDetailObj.assigneeId === this.loginUserId))) {
                    // 进行最后保存
                    await this.handleTimeconfigFormSave();
                }
                this.isShowTaskTimeDialog = false;
            },
            sumChildrenDays (arr, lastEndTime, isBatchUpdateDate) { // 计算树节点的开始与结束日期
                let innerLastEndTime = lastEndTime;
                let isFirst = true;
                for (let item of arr) {
                    if (item.pId === 0) {
                        this.taskSumTotalDays = Number(this.taskSumTotalDays) + Number(item.workingDays);
                    }
                    if (isBatchUpdateDate) {
                        // console.log(item.workingDays);
                        if (item.workingDays === 0) {
                            item.planStartTime = innerLastEndTime;
                            item.planEndTime = innerLastEndTime;
                        } else {
                            if (innerLastEndTime !== '') {
                                item.planStartTime = this.addDates(innerLastEndTime, isFirst ? 0 : 1);
                                if (isFirst) {
                                    isFirst = false;
                                }
                            }
                            if (item.planStartTime !== '') {
                            // item.planEndTime = this.addDateHours(item.planStartTime, Number(item.workingDays));
                                item.planEndTime = this.addDates(item.planStartTime, Number(item.workingDays) - 1);
                                innerLastEndTime = item.planEndTime;
                            }
                        }

                        if (item.children) {
                            this.sumChildrenDays(item.children, item.planStartTime, isBatchUpdateDate);
                        }
                    } else {
                        innerLastEndTime = '';
                    }
                }
            },
            // sumParentDays (arr, dVal) { // 计算树节点的父节点累计工作时长
            //     for (let item of arr) {
            //         if (item.workingDays && item.id === this.configDetailObj.id) {
            //             if (item.pItem) {
            //                 // item.pItem.workingDays = Number(item.pItem.workingDays) + Number(dVal);
            //                 this.setParentDays(item.pItem, dVal);
            //             }
            //         }
            //         if (item.children) {
            //             this.sumParentDays(item.children, dVal);
            //         }
            //     }
            // },
            async sumParentDays (arr) { // 计算树节点的父节点累计工作时长
                let isFirst = true;
                for (let item of arr) {
                    if (item.children) {
                        if (isFirst) {
                            isFirst = false;
                        }
                        this.sumParentDays(item.children);
                    } else if (item.pItem) {
                        if (isFirst) {
                            item.pItem.isFirst = true;
                            isFirst = false;
                        } else {
                            item.pItem.isFirst = false;
                        }
                        this.setParentDays(item.pItem, item.workingDays);
                    }
                }
            },
            setParentDays (item, dVal) {
                if (item.isFirst) {
                    item.workingDays = Number(dVal);
                } else {
                    item.workingDays = Number(item.workingDays) + Number(dVal);
                }
                if (item.pItem) {
                    if (item.pItem.pId === 0) {
                        return;
                    }
                    if (item.pItem.pId === 0 && item.pItem.isFirst) {
                        item.pItem.isFirst = false;
                    } else {
                        item.pItem.isFirst = true;
                    }
                    this.setParentDays(item.pItem, item.workingDays);
                }
            },
            sumFisrtLevel (arr) {
                for (let item of arr) {
                    let totalDays = 0;
                    if (!isEmpty(item.children)) {
                        for (let subItem of item.children) {
                            totalDays = Number(totalDays) + Number(subItem.workingDays);
                        }
                        item.workingDays = totalDays;
                    }
                }
            },
            initTotalDays () {
                this.taskSumTotalDays = 0;
                let treeDatas = this.$refs.treeTableDragRef.getCurrentTreeData();
                for (let item of treeDatas) {
                    if (item.workingDays) {
                        this.taskSumTotalDays = Number(this.taskSumTotalDays) + Number(item.workingDays);
                    }
                }
            },
            addDateHours (sTime, hoursNum) { // hoursNum 小时数
                let tt = sTime;
                let time = new Date(tt);
                time.setHours(time.getHours() + hoursNum);
                time = new Date(time);
                let transTime = time.getFullYear() + '-' + this.appendZero((time.getMonth() + 1)) + '-' + this.appendZero(time.getDate()) + ' ' + this.appendZero(time.getHours()) + ':' + this.appendZero(time.getMinutes()) + ':' + this.appendZero(time.getSeconds());
                return transTime;
            },
            addDates (sTime, daysNum) { // daysNum 天数
                let tt = sTime;
                let time = new Date(tt);
                time.setHours(time.getHours() + daysNum * 24);
                time = new Date(time);
                let transTime = time.getFullYear() + '-' + this.appendZero((time.getMonth() + 1)) + '-' + this.appendZero(time.getDate());
                return transTime;
            },
            appendZero (source) {
                if (source < 10) {
                    return '0' + source;
                } else {
                    return source;
                }
            },
            handleFullScreen () {
                this.$emit('handleFullScreenForTime');
            },
            chooseUser () {
                setTimeout(() => { // 初始化
                    this.$refs.userOrgPop._initPage();
                }, 0);
                this.isShowUserOrg = true;
            },
            selectTrigger (selected) {
                this.configDetailObj.assigneeId = selected.selectedUserIds;
                this.configDetailObj.assigneeName = selected.selectedUserNames;
            },
            treeDataChange (list) {
                this.treeDatas = list;
            },
            async changeSwitch () {
                this.$refs.treeTableDragRef._resetExpandAll(this.expandAll);
                this.loadTimer = new Date().getTime();
                // setTimeout(() => {
                await this.$refs.treeTableDragRef._resetData(this.treeDatas);
                // }, 0);
            },
            changeExpandStatus (arr) { // 计算树节点的开始与结束日期
                for (let item of arr) {
                    item.open = this.expandAll;
                    if (item.children) {
                        this.changeExpandStatus(item.children);
                    }
                }
            },
			      async exportTimeConfigDetailToExcel () {
                let url = `${API_PROCESS_TIME_CONFIG_DETAIL_TO_EXCEL}`;
                url = url.replace(':processInstanceId', this.instancesInfo.id).replace(':templateId', this.projectMainLine.id);
                this.download(url);
            },
            download (url) {
                var iframe = document.createElement('iframe');
                iframe.style.display = 'none';
                iframe.src = url;
                document.body.appendChild(iframe);
            },
            async handleNavViewTimeGantt () {
                // let timeGanttInfo = await getPlanTimeGantt(this.instancesInfo.id);
                // 调用子组件方法
                setTimeout(() => { // 默认回显值
                    // this.$refs.timeGannt._setDefault(timeGanttInfo);
                    this.$refs.timeConfigGantt.initPage(this.instancesInfo.id);
                }, 0);
                this.loadTimer = new Date().getTime();
                this.isShowTimeGantt = true;
                // tooltip出不来，改为跳页方式
                // this.navTimeConfigGantt(this.instancesInfo.id);
            },
            async handelSetMainTask () {
                if (this.configDetailObj.taskStatus === 2) {
                    this.$message({
                        message: '不能干预配置已完成的任务节点!',
                        type: 'warning',
                        duration: 2000
                    });
                    return false;
                }

                // console.log(row);
                let taskId = this.configDetailObj.taskId;
                let taskName = this.configDetailObj.label;
                let processServiceId = this.instancesInfo.processServiceId;
                let deploymentId = this.instancesInfo.deploymentId;
                // console.log(this.instancesInfo);
                if (taskId) {
                    this.loadTimer = new Date().getTime();
                    let taskData = await getProcessServiceInstanceConfig(processServiceId, deploymentId, this.instancesInfo.id, taskId);
                    this.taskData = defaultsDeep(taskData, {
                        taskId: taskId,
                        taskName: taskName,
                        processServiceId: processServiceId,
                        deploymentId: deploymentId
                    }, defaultElementData);
                    this.taskTile = '【' + this.instancesInfo.name + '】: ' + taskData.taskName;
                    this.taskData.executor.isInitconfig = false;
                    this.taskData.processInstanceId = this.instancesInfo.id;
                    this.taskData.status = this.configDetailObj.taskStatus;
                    this.taskData.taskInstanceId = this.configDetailObj.taskInstanceId;
                    this.isShowEleEditor = true;
                    this.isShowSaveBtn = true;
                }
            },
            hideMainSaveBtn (flg) {
                this.isShowSaveBtn = flg;
            },
            async handleSaveConfig () {
                if (this.taskData.nodeInfo.isApproval === 1 && isEmpty(this.taskData.nodeInfo.approvalTemplateList)) {
                    this.$message({message: '当前任务为审批节点，请选择审批流模板！', type: 'warning'});
                    return;
                }
                if (this.taskData.nodeInfo.isSubProcess === 1 && isEmpty(this.taskData.nodeInfo.subProcesslTemplateList)) {
                    this.$message({message: '当前任务为业务流节点，请选择业务流模板！', type: 'warning'});
                    return;
                }
                if (this.taskData.executor.modeType === 2) { // 会签任务
                    // 校验会签人员是否存在
                    if (isEmpty(this.taskData.executor.countersignUsers)) {
                        this.$message({message: '当前会签节点未配置负责人，请配置后再保存', type: 'warning'});
                        return false;
                    }
                }
                this.$confirm(`您确定要修改当前任务配置吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    const loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });

                    // 解决未知错误
                    // console.log(this.taskData.nodeInfo.approvalTemplateList);
                    // 转换showAllMyApprovals的值Integer为Boolean
                    if (this.taskData.nodeInfo.approvalTemplateList && this.taskData.nodeInfo.approvalTemplateList.length > 0) {
                        this.taskData.nodeInfo.approvalTemplateList.forEach(element => {
                            element.showAllMyApprovals = (element.showAllMyApprovals > 0);
                        });
                    }

                    await interveneProcessTaskConfig(this.taskData);
                    loading.close();
                    // this.$emit('refreshProcessList', true);
                    this.isShowEleEditor = false;
                    this.isShowTaskTimeDialog = false;
                    this.$emit('initProjectMainLine');
                }).catch(() => {});
            },
            handleTimeTemplateForms () {
                this.timeTemplateInstanceId = this.projectMainLine.id;
                this.isShowTimeTemplateInstanceFormsDialog = true;
            },
            async  handleViewTaskDetail (item) {
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    console.log(item);
                    this.taskInfo = await getProcessTaskDetail(item.subProcessFirstTaskInstanceId);
                    this.loadTimer = new Date().getTime();
                    // console.log('handleViewTaskDetail', this.isShowNewMode);
                    this.syscnt++;
                    if (this.syscnt / 2 === 0) {
                        this.isShowTaskDetailDrawer = true;
                    } else {
                        this.isShowTaskDetail = true;
                    }
                } catch (error) {
                    console.log(error);
                } finally {
                    loading.close();
                }
            },
            async setBreadcrumb (obj) {
                await this.queryTreeList(obj);
                let treeFileArr = [
                    {path: '', key: '-1', meta: {title: '主线目录'}},
                    {path: '', key: this.treeDatas[0].id, meta: { title: this.treeDatas[0].label }}
                ];
                this.treeId = this.treeDatas[0].id + '';
                this.directoryList = treeFileArr;
            },
            async handleBreadcrumb (obj, index) {
                this.directoryList[index].path = '';
                this.treeId = obj.key + '';
                this.treeName = obj.meta.title;
                let temp = [];
                for (var i = 0; i < index + 1; i++) {
                    temp.push(this.directoryList[i]);
                }
                console.log(this.directoryList);
                this.directoryList = temp;
                await this.queryTreeList({processInstanceId: obj.key});
            },
            async handleSearch () {
                // await this.queryTreeList({processInstanceId: obj.key});
            },
            async handleEnterSubMainLine (row) { // 进入文件夹
                if (!row.root) {
                    let ROUTER_BASE_PATH = getGlobalConf().routerBasePath;
                    this.directoryList[this.directoryList.length - 1].path = ROUTER_BASE_PATH + this.rootPath;
                    this.directoryList.push({path: '', key: row.id, meta: {title: row.label}});
                    this.treeId = row.id + '';
                    console.log(this.directoryList);
                    await this.queryTreeList({processInstanceId: row.id});
                }
            },
            async handleViewAllProjectMainLine () {
                let obj = {};
                obj.processInstanceId = this.rootProcessInstanceId;
                obj.isAll = true;
                await this.queryTreeList(obj);
            },
            async refreshSubProcess () {
                await this.queryTreeList({processInstanceId: this.treeId});
            },
            handleClosePop () {
                this.isShowStartProcessDialog = false;
            },
            async handleTaskComplete (taskData) {
                // console.log(this.taskInfo);
                let task = {
                    taskDefinitionKey: this.taskInfo.taskDefinitionKey,
                    processInstanceId: this.taskInfo.processInstanceId,
                    processServiceId: this.taskInfo.processServiceId,
                    deploymentId: this.taskInfo.processDefinitionDeploymentId,
                    taskId: this.taskInfo.id,
                    operateType: taskData.operateType,
                    btnConditions: taskData.btnConditions,
                    operateOpinion: taskData.operateOpinion,
                    forms: taskData.forms,
                    modelInstanceIds: taskData.modelInstanceIds,
                    isApproval: this.taskInfo.taskNode.isApproval,
                    canUnStartApproval: this.taskInfo.taskNode.canUnStartApproval,
                    isSubProcess: this.taskInfo.taskNode.isSubProcess,
                    needAllSubProcess: this.taskInfo.taskNode.needAllSubProcess,
                    mainModelInfo: taskData.mainModelInfo,
                    operateName: taskData.operateName,
                    mainDataModelInstanceIds: taskData.mainDataModelInstanceIds
                };
                let loading;
                try {
                    loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    if (this.taskInfo.formObj) {
                        await this.renderSerialNumber(this.taskInfo.formObj.structure, task.forms, taskData.operateType);
                    }
                    await processTaskComplete(task);
                    loading.close();
                    this.isShowTaskDetailDrawer = false;
                    this.isShowTaskDetail = false;
                    await this.refreshSubProcess();
                } catch (error) {
                    console.error('任务保存出错：' + error);
                    loading.close();
                }
                // console.log(task);
            },
            async handleTaskDelete () {
                // console.log(task);
                this.$confirm(`您确定要删除任务吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    const loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    await processTaskDelete(this.taskInfo.processInstanceId, this.taskInfo.id);
                    loading.close();
                    this.isShowTaskDetailDrawer = false;
                    this.isShowTaskDetail = false;
                    await this.refreshSubProcess();
                }).catch(() => {});
            },
            async transferTask (param) {
                this.$confirm(`您确定要转办任务吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    await transferAssignee(param);
                    await this.refreshSubProcess();
                    this.isShowTaskDetailDrawer = false;
                    this.isShowTaskDetail = false;
                }).catch(() => {});
            },
            async handleTaskTemporarySave (taskData) {
                let task = {
                    taskDefinitionKey: this.taskInfo.taskDefinitionKey,
                    processInstanceId: this.taskInfo.processInstanceId,
                    processServiceId: this.taskInfo.processServiceId,
                    deploymentId: this.taskInfo.processDefinitionDeploymentId,
                    taskId: this.taskInfo.id,
                    forms: taskData.forms,
                    btnConditions: taskData.btnConditions,
                    modelInstanceIds: taskData.modelInstanceIds,
                    operateOpinion: taskData.operateOpinion,
                    mainModelInfo: taskData.mainModelInfo
                };
                // console.log(JSON.stringify(task, null, 2));
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    await this.renderSerialNumber(this.taskInfo.formObj.structure, task.forms, '1');// 1:代表完成，暂存于完成生成流水号规则一致
                    await processTaskTemporarySave(task);
                    loading.close();
                    await this.refreshTaskDetail(this.taskInfo.id);
                } catch (error) {
                    console.log(error);
                } finally {
                    loading.close();
                }
            },
            async renderSerialNumber (forms, formData, operateType) {
                if (forms && formData && forms.length > 0 && formData.length > 0) {
                    for (var dIndex = 0; dIndex < formData.length; dIndex++) {
                        // if (formData[dIndex].values.id) {
                        //     continue;
                        // }
                        let fData = formData[dIndex];
                        for (var findex = 0; findex < forms.length; findex++) {
                            let formInfo = forms[findex];
                            // 流水号保存生成字段渲染
                            if (fData.formId === formInfo.id && formInfo.fieldsList && formInfo.fieldsList.length > 0) {
                                for (var fieldIndex = 0; fieldIndex < formInfo.fieldsList.length; fieldIndex++) {
                                    let field = formInfo.fieldsList[fieldIndex];
                                    // 假如是流水号字段并且流水号有值的情况下就不走流水号生成逻辑了
                                    if (field.type === 'serialNumber' && !isEmpty(fData.values[field.id])) {
                                        console.log(field.name + '---------' + field.type);
                                        console.log(fData.values[field.id]);
                                        continue;
                                    }
                                    if (field.type === 'subform' && fData.values[field.id] && fData.values[field.id].length > 0) {
                                        for (var dataIndex = 0; dataIndex < fData.values[field.id].length; dataIndex++) {
                                            var subData = fData.values[field.id][dataIndex];
                                            for (var subFieldIndex = 0; subFieldIndex < field.options.fieldList.length; subFieldIndex++) {
                                                let subField = field.options.fieldList[subFieldIndex];
                                                if (subField.type === 'serialNumber' && subField.options.ext3 === '2' && !formData[dIndex].values.id && subField.options.config.options.length > 0 && !subData[subField.id]) {
                                                    await this.setSerialNumber(subField.options.config.options[0].value, subField, subData, formInfo);
                                                } else if (subField.type === 'serialNumber' && subField.options.ext3 === '4' && operateType === '2' && !subField.isRead && subField.options.config.options.length > 0 && !subData[subField.id]) {
                                                    await this.setSerialNumber(subField.options.config.options[0].value, subField, subData, formInfo);
                                                }
                                            }
                                        }
                                        // field.type === 'serialNumber' 审批流字段
                                        // field.options.ext3,'2'：保存后生成，4：审批后生成
                                        // operateType，1:完成（即保存），2：同意/通过（即审批通过）
                                        // field.isRead,true（disabled）：不可编辑，其他（false/null），可编辑
                                        // fData.values[field.formField],判断此字段是否已存在
                                    } else if (field.type === 'serialNumber' && field.options.ext3 === '2' && !formData[dIndex].values.id && field.options.config.options.length > 0 && !fData.values[field.formField]) {
                                        await this.setSerialNumber(field.options.config.options[0].value, field, fData.values, formInfo);
                                    } else if (field.type === 'serialNumber' && field.options.ext3 === '4' && operateType === '2' && !field.isRead && field.options.config.options.length > 0 && !fData.values[field.formField]) {
                                        await this.setSerialNumber(field.options.config.options[0].value, field, fData.values, formInfo);
                                    } else if (field.type === 'serialNumber' && field.options.ext3 === '6') { // 根据字段值进行生成流水号
                                        let ext2Obj = JSON.parse(field.options.ext2);
                                        let curFieldValue = fData.values[ext2Obj.seriaNumberGenerateFieldId];
                                        if (ext2Obj.seriaNumberGenerateFieldIdValue && typeof (ext2Obj.seriaNumberGenerateFieldIdValue) === 'object') {
                                            for (let i = 0; i < ext2Obj.seriaNumberGenerateFieldIdValue.length; i++) {
                                                if (curFieldValue === ext2Obj.seriaNumberGenerateFieldIdValue[i]) {
                                                    await this.setSerialNumber(field.options.config.options[0].value, field, fData.values, formInfo);
                                                }
                                            }
                                        } else {
                                            if (curFieldValue === ext2Obj.seriaNumberGenerateFieldIdValue) {
                                                await this.setSerialNumber(field.options.config.options[0].value, field, fData.values, formInfo);
                                            }
                                        }
                                    } else if (field.type === 'serialNumber') { // 多规则的流水号生成规则
                                        let ext2 = field.options.ext2;
                                        if (ext2) {
                                            let ext2Obj = JSON.parse(ext2);
                                            if (ext2Obj.moreSerialNumber) { // 多规则配置
                                                let seriaNumberAutoincrementType = null;
                                                let serialNumberRuleList = ext2Obj.serialNumberRuleList;
                                                for (let i = 0; i < serialNumberRuleList.length; i++) {
                                                    let element = serialNumberRuleList[i];
                                                    let takeEffectField = element.takeEffectField;
                                                    let takeEffectFieldValue = element.takeEffectFieldValue;
                                                    let formFieldVal = fData.values[takeEffectField];
                                                    if (element.seriaNumberAutoincrementType) { // 说明配置了自增体 1部门自增体 流水号自增体
                                                        seriaNumberAutoincrementType = element.seriaNumberAutoincrementType;
                                                    }
                                                    if (takeEffectFieldValue.indexOf(formFieldVal) !== -1) { // 满足条件了
                                                        if (element.seriaNumberDepartTypeFormFieldId) {
                                                            ext2Obj.seriaNumberDepartTypeFormFieldId = element.seriaNumberDepartTypeFormFieldId;
                                                        }
                                                        if (element.seriaNumberDepartTypeFormFieldIdValue) {
                                                            ext2Obj.seriaNumberDepartTypeFormFieldIdValue = element.seriaNumberDepartTypeFormFieldIdValue;
                                                        }
                                                        if (element.seriaNumberSelectTypeFormFieldId) {
                                                            ext2Obj.seriaNumberSelectTypeFormFieldId = element.seriaNumberSelectTypeFormFieldId;
                                                        }
                                                        field.options.ext2 = JSON.stringify(ext2Obj);
                                                        await this.setSerialNumber(element.selectedNode.id, field, fData.values, formInfo, seriaNumberAutoincrementType);
                                                        break;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            },
            async setSerialNumber (sid, field, formData, formInfo, seriaNumberAutoincrementType) {
                // if (sid) {
                //     let numberObj = await getSerialNumber(sid);
                //     if (numberObj) {
                //         formData[field.formField] = numberObj.newSerialNumber;
                //         formData[field.formField + '-sn'] = numberObj.sn;
                //     }
                // }
                if (sid) {
                    let busiId = null;
                    let departId = null;
                    let configOptionId = null;
                    let upSerialNumber = null; // 国融合同表单框架合同号
                    for (var fieldIndex = 0; fieldIndex < formInfo.fieldsList.length; fieldIndex++) {
                        let tempField = formInfo.fieldsList[fieldIndex];
                        if (tempField.type === 'businessTree') {
                            busiId = formData[tempField.formField];
                        } else if (tempField.type === 'department') {
                            departId = formData[tempField.formField];
                        } else if (tempField.type === 'select') {
                            // 中泽的项目立项表的业务分类选项字段
                            if (tempField.id === '1d3bb7fd093943709bfbd36fd6c15ca4') {
                                let optionValue = formData[tempField.formField];
                                let configOptions = tempField.options.config.options;
                                for (let k = 0; k < configOptions.length; k++) {
                                    let item = configOptions[k];
                                    if (item.value === optionValue) {
                                        configOptionId = item.id;
                                        break;
                                    }
                                }
                            }
                        } else if (tempField.type === 'link') {
                            if (formInfo.id === 'b81cbd9fa972415ebb00d3e40e1f5522') { // 国融【合同信息表】
                                if (tempField.id === '7abddcef62424e4b99145cfa7080e42c') { // 合同表单的【关联框架合同】字段
                                    let linkObj = formData[tempField.formField];
                                    // console.log(linkObj);
                                    if (linkObj) {
                                        let linkObjTableData = linkObj['tableData'][0];
                                        if (linkObjTableData) {
                                            // 合同编号 c6219b4ce1e94150b0f0a00ab63ecf83
                                            upSerialNumber = linkObjTableData['c6219b4ce1e94150b0f0a00ab63ecf83'];
                                            // console.log(upSerialNumber);
                                        }
                                    }
                                }
                            }
                        };
                    }
                    let numberObj = null;
                    let instanceId = null;
                    let serialNumberRefId = null;
                    let serialNumberRelationFormId = null;
                    let serialNumberRelationFieldId = null;
                    let departmentId = null;
                    if (field.options.ext2) {
                        let ext2Obj = JSON.parse(field.options.ext2);
                        if (ext2Obj.seriaNumberFormFieldId) { // 部门占位符取值
                            departmentId = formData[ext2Obj.seriaNumberFormFieldId];
                            if (departmentId) {
                                departmentId = Number(departmentId);
                                let param = {id: sid, busiId: busiId, departId: departId, departmentId: departmentId};
                                if (seriaNumberAutoincrementType) {
                                    param.seriaNumberAutoincrementType = seriaNumberAutoincrementType;
                                }
                                numberObj = await getSerialNumberDepartment(param);
                            } else {
                                this.$message.error('流水号关联的部门未选取,数据无法生成流水号');
                                return;
                            }
                        } else if (ext2Obj.seriaNumberBusinessTypeFormFieldId && ext2Obj.seriaNumberDepartTypeFormFieldId) { // 业务分类和部门都选择的
                            let businessId = formData[ext2Obj.seriaNumberBusinessTypeFormFieldId];
                            let departId = formData[ext2Obj.seriaNumberDepartTypeFormFieldId];
                            let param = {id: sid, businessId: businessId, businessField: ext2Obj.seriaNumberBusinessTypeFormFieldIdValue, departId: departId, departField: ext2Obj.seriaNumberDepartTypeFormFieldIdValue};
                            if (ext2Obj.seriaNumberSelectTypeFormFieldId) {
                                let fieldVal = formData[ext2Obj.seriaNumberSelectTypeFormFieldId];
                                if (fieldVal) { // 下拉选项选值了
                                    let fieldObj = formInfo.fieldsList.find(element => element.id === ext2Obj.seriaNumberSelectTypeFormFieldId);
                                    let options = fieldObj.options.config.options;
                                    let optionsObj = options.find(element => element.value === fieldVal);
                                    // if (optionsObj.serialNumberValue) {
                                    param.seriaNumberSelectTypeFormVal = optionsObj.serialNumberValue;
                                    param.seriaNumberSelectTypeFormFieldId = ext2Obj.seriaNumberSelectTypeFormFieldId;
                                    if (seriaNumberAutoincrementType) {
                                        param.seriaNumberAutoincrementType = seriaNumberAutoincrementType;
                                    }
                                    // }
                                }
                            }
                            numberObj = await getSerialNumberPlus(param);
                        } else if (ext2Obj.seriaNumberBusinessTypeFormFieldId) { // 业务分类
                            let businessId = formData[ext2Obj.seriaNumberBusinessTypeFormFieldId];
                            let param = {id: sid, businessId: businessId, businessField: ext2Obj.seriaNumberBusinessTypeFormFieldIdValue};
                            if (ext2Obj.seriaNumberSelectTypeFormFieldId) {
                                let fieldVal = formData[ext2Obj.seriaNumberSelectTypeFormFieldId];
                                if (fieldVal) { // 下拉选项选值了
                                    let fieldObj = formInfo.fieldsList.find(element => element.id === ext2Obj.seriaNumberSelectTypeFormFieldId);
                                    let options = fieldObj.options.config.options;
                                    let optionsObj = options.find(element => element.value === fieldVal);
                                    // if (optionsObj.serialNumberValue) {
                                    param.seriaNumberSelectTypeFormVal = optionsObj.serialNumberValue;
                                    param.seriaNumberSelectTypeFormFieldId = ext2Obj.seriaNumberSelectTypeFormFieldId;
                                    if (seriaNumberAutoincrementType) {
                                        param.seriaNumberAutoincrementType = seriaNumberAutoincrementType;
                                    }
                                    // }
                                }
                            }
                            numberObj = await getSerialNumberPlus(param);
                        } else if (ext2Obj.seriaNumberDepartTypeFormFieldId) { // 部门
                            let departId = formData[ext2Obj.seriaNumberDepartTypeFormFieldId];
                            let param = {id: sid, departId: departId, departField: ext2Obj.seriaNumberDepartTypeFormFieldIdValue};
                            if (ext2Obj.seriaNumberSelectTypeFormFieldId) {
                                let fieldVal = formData[ext2Obj.seriaNumberSelectTypeFormFieldId];
                                if (fieldVal) { // 下拉选项选值了
                                    let fieldObj = formInfo.fieldsList.find(element => element.id === ext2Obj.seriaNumberSelectTypeFormFieldId);
                                    let options = fieldObj.options.config.options;
                                    let optionsObj = options.find(element => element.value === fieldVal);
                                    // if (optionsObj.serialNumberValue) {
                                    param.seriaNumberSelectTypeFormVal = optionsObj.serialNumberValue;
                                    param.seriaNumberSelectTypeFormFieldId = ext2Obj.seriaNumberSelectTypeFormFieldId;
                                    if (seriaNumberAutoincrementType) {
                                        param.seriaNumberAutoincrementType = seriaNumberAutoincrementType;
                                    }
                                    // }
                                }
                            }
                            numberObj = await getSerialNumberPlus(param);
                        } else if (ext2Obj.seriaNumberSelectTypeFormFieldId) {
                            let param = {id: sid};
                            if (ext2Obj.seriaNumberSelectTypeFormFieldId) {
                                let fieldVal = formData[ext2Obj.seriaNumberSelectTypeFormFieldId];
                                if (fieldVal) { // 下拉选项选值了
                                    let fieldObj = formInfo.fieldsList.find(element => element.id === ext2Obj.seriaNumberSelectTypeFormFieldId);
                                    let options = fieldObj.options.config.options;
                                    let optionsObj = options.find(element => element.value === fieldVal);
                                    //   if (optionsObj.serialNumberValue) {
                                    param.seriaNumberSelectTypeFormVal = optionsObj.serialNumberValue;
                                    param.seriaNumberSelectTypeFormFieldId = ext2Obj.seriaNumberSelectTypeFormFieldId;
                                    if (seriaNumberAutoincrementType) {
                                        param.seriaNumberAutoincrementType = seriaNumberAutoincrementType;
                                    }
                                    //   }
                                }
                            }
                            numberObj = await getSerialNumberPlus(param);
                        } else {
                            if (field.ext1) {
                                let serialNumberRelation = JSON.parse(field.ext1);
                                serialNumberRefId = serialNumberRelation.serialNumberRefId;
                                serialNumberRelationFormId = serialNumberRelation.serialNumberRelationFormId;
                                serialNumberRelationFieldId = serialNumberRelation.serialNumberRelationFieldId;
                                instanceId = formData[serialNumberRefId].tableData[0].id;
                            }
                            if (instanceId && serialNumberRefId) {
                                numberObj = await getSerialNumber2(instanceId, serialNumberRefId, serialNumberRelationFormId, serialNumberRelationFieldId);
                            } else if (busiId && departId) {
                                numberObj = await getSerialNumber(sid, busiId, departId);
                            } else if (departId && configOptionId) { // 根据部门和选项值获取流水号
                                numberObj = await getSerialNumberDepAndOption(sid, departId, configOptionId);
                            } else {
                                numberObj = await getSerialNumber(sid);
                            }
                        }
                    } else {
                        if (field.ext1) {
                            let serialNumberRelation = JSON.parse(field.ext1);
                            serialNumberRefId = serialNumberRelation.serialNumberRefId;
                            serialNumberRelationFormId = serialNumberRelation.serialNumberRelationFormId;
                            serialNumberRelationFieldId = serialNumberRelation.serialNumberRelationFieldId;
                            instanceId = formData[serialNumberRefId].tableData[0].id;
                        }
                        if (instanceId && serialNumberRefId) {
                            numberObj = await getSerialNumber2(instanceId, serialNumberRefId, serialNumberRelationFormId, serialNumberRelationFieldId);
                        } else if (busiId && departId) {
                            numberObj = await getSerialNumber(sid, busiId, departId);
                        } else if (departId && configOptionId) { // 根据部门和选项值获取流水号
                            numberObj = await getSerialNumberDepAndOption(sid, departId, configOptionId);
                        } else {
                            numberObj = await getSerialNumber(sid);
                        }
                    }
    
                    // let numberObj = await getSerialNumber(sid);
                    if (numberObj) {
                        formData[field.formField] = numberObj.newSerialNumber;
                        formData[field.formField + '-sn'] = numberObj.sn;
                        if (upSerialNumber) {
                            formData[field.formField] = upSerialNumber + '-' + numberObj.newSerialNumber;
                        }
                        // console.log(formData[field.formField]);
                    }
                }
            }
        }
    };
</script>

<style lang="less">
    .projectMainLine-detail {
        width: 100%;
        margin-top: -1%;
        margin-bottom: -2%;
        .projectMainLine-form {
            // width: 700px;
        };
        .dragTreeTableDiv .drag-tree-table{
          .drag-tree-table-header .tree-column {
              padding: 0 4px;
              min-width: 60px;
              text-align: left;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
          }
          .drag-tree-table-body .tree-column{
              padding: 0 4px;
              min-width: 60px;
              text-align: left;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
        }

        .project-template{
            a{color:#606266}
            a:link {
              color:#606266;
              text-decoration:none;
            }
            a:hover{
              color:#09AAFF;
              text-decoration:none;
            }
            .tools-bar{
                  margin: 5px;
            }
            .projectTemplate {
                margin-top: 5px;
                margin-left: 10px;
                margin-bottom: 5px;
                background: #fff;
            }
            .form-list {
                width: 100%;
            }
            .el-dropdown-link {
              cursor: pointer;
              color: #409eff;
            }
            .show-file-info{
              margin-right: 20px;
              float: right;
              font-size: 12px;
              color: rgb(102, 102, 102);
              font: "12px/1.5 "Microsoft YaHei", arial, SimSun, 宋体;"
            }
            .tools-btn-group{
              margin-top: 1px;
              float: right;
            }
        }
    }
   .task-edit-dialog {
        width: 800px;
        min-width: 600px;
        // max-width: 1200px;
    }
    .needWorkingPop{
        .task-detail{
            height: 100%;
            .task-content{
                height: ~"calc(100% - 120px)";
                .el-tabs{
                    height: ~"calc(100% - 120px)";
                    overflow: auto;
                }
            }
        }
        .drawerWorkTask{
            .tools-bar{
                position:static;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/workbench/ProjectMainLine/ProjectMainLineDetail.vue